import React from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../paths';

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  return (
    // Added 'min-h-screen' and 'flex items-center justify-center' here
    <div className="w-full min-h-screen flex flex-col items-center justify-center text-center p-6 bg-transparent">
      {/* Success Icon/Graphic Element */}
      <div className="mb-6 bg-[#CC5E15]/20 p-4 rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-[#CC5E15]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      {/* Added 'leading-tight' and 'py-2' to ensure the 'g' or other characters aren't clipped */}
      <h1 className="text-4xl sm:text-5xl font-bold font-barlow text-black mb-2 leading-tight py-2">
        Success!
      </h1>
      
      <p className="text-sm font-semibold font-montserrat text-black tracking-wider uppercase mb-4">
        Registration Complete
      </p>

      <div className="max-w-md mb-8">
        <p className="text-xs sm:text-sm text-gray-600 font-montserrat leading-relaxed">
          Congratulations! You are now part of the Spirit community. The CA Program is now live—get ready to represent your campus and compete with the best.
        </p>
      </div>

      <button 
        onClick={() => navigate(paths.login)} 
        className="w-full max-w-[200px] bg-black hover:bg-gray-900 text-white font-bold text-xs py-3 rounded-sm transition-colors tracking-widest font-montserrat"
      >
        Login Now
      </button>

      {/* Footer tagline */}
      <div className="mt-12">
        <p className="text-[9px] uppercase tracking-widest text-gray-600 font-medium">
          Together, we're redefining what student sport can be.
        </p>
      </div>
    </div>
  );
};

export default RegistrationSuccess;